import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=a4fbbf26&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4fbbf26')) {
      api.createRecord('a4fbbf26', component.options)
    } else {
      api.reload('a4fbbf26', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=a4fbbf26&", function () {
      api.rerender('a4fbbf26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cAjWdx0io44T/JS/comp/offers.vue"
export default component.exports